import { FileDown } from "lucide-react";
import {
  COMPANY_DECK_LABEL,
  COMPANY_DECK_URL,
  COMPANY_DECK_FILENAME,
} from "../../constants/company-deck";

const brandClasses =
  "bg-navy text-white hover:bg-[#162d4a] shadow-sm shadow-navy/15 border border-teal/25";

export default function CompanyDeckButton({
  className = "",
  compact = false,
  shortLabel = false,
}) {
  const label = shortLabel ? "Company Deck (PDF)" : COMPANY_DECK_LABEL;

  if (compact) {
    return (
      <a
        href={COMPANY_DECK_URL}
        download={COMPANY_DECK_FILENAME}
        className={`inline-flex items-center justify-center rounded-full ${brandClasses} transition-colors p-2.5 shrink-0 ${className}`}
        aria-label={COMPANY_DECK_LABEL}
        title={COMPANY_DECK_LABEL}
      >
        <FileDown className="w-5 h-5 text-teal" aria-hidden />
      </a>
    );
  }

  return (
    <a
      href={COMPANY_DECK_URL}
      download={COMPANY_DECK_FILENAME}
      className={`inline-flex items-center justify-center gap-2 rounded-full ${brandClasses} font-medium transition-colors text-center px-4 sm:px-5 py-2.5 text-sm ${className}`}
      title={COMPANY_DECK_LABEL}
    >
      <FileDown className="w-5 h-5 shrink-0 text-teal" aria-hidden />
      <span className="leading-snug">{label}</span>
    </a>
  );
}
